export { default } from './InquiryContent';
